import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1524.82353,1242.35294 C1618.22588,1242.35294 1694.23529,1318.36235 1694.23529,1411.76471 L1694.23529,1411.76471 L1694.23529,1750.58824 C1694.23529,1843.99059 1618.22588,1920 1524.82353,1920 L1524.82353,1920 L395.411765,1920 C302.009412,1920 226,1843.99059 226,1750.58824 L226,1750.58824 L226,1411.76471 C226,1318.36235 302.009412,1242.35294 395.411765,1242.35294 L395.411765,1242.35294 Z M1016.58824,0 L1016.58824,338.823529 L903.647059,338.823529 L903.647059,0 L1016.58824,0 Z M564.823529,1468.23529 C627.167059,1468.23529 677.764706,1518.94588 677.764706,1581.17647 C677.764706,1643.40706 627.167059,1694.11765 564.823529,1694.11765 C502.48,1694.11765 451.882353,1643.40706 451.882353,1581.17647 C451.882353,1518.94588 502.48,1468.23529 564.823529,1468.23529 Z M903.647059,338.823529 L903.647059,767.209412 L657.322353,520.884706 L577.472941,600.734118 L960.117647,983.378824 L1342.76235,600.734118 L1262.91294,520.884706 L1016.58824,767.209412 L1016.58824,338.823529 L1524.82353,338.823529 C1618.56471,338.823529 1694.23529,414.494118 1694.23529,508.235294 L1694.23529,508.235294 L1694.23529,1185.88235 C1647.92941,1150.87059 1588.07059,1129.41176 1524.82353,1129.41176 L1524.82353,1129.41176 L395.411765,1129.41176 C332.164706,1129.41176 272.305882,1150.87059 226,1185.88235 L226,1185.88235 L226,508.235294 C226,414.494118 301.670588,338.823529 395.411765,338.823529 L395.411765,338.823529 L903.647059,338.823529 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSaveSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconSaveSolid, _Component);

  var _super = _createSuper(IconSaveSolid);

  function IconSaveSolid() {
    _classCallCheck(this, IconSaveSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconSaveSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSave",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSaveSolid.displayName = "IconSaveSolid";
  return IconSaveSolid;
}(Component);

IconSaveSolid.glyphName = 'save';
IconSaveSolid.variant = 'Solid';
IconSaveSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSaveSolid;
export { IconSaveSolid };